import React, { useState } from 'react';
import './FAQ.css';

const faqData = [
  {
    question: "What is Genix AI?",
    answer: "Genix AI is an AI-powered telehealth platform that offers tools such as real-time transcription, multilingual support, and predictive analytics to streamline healthcare delivery. It integrates with systems like the NHS to enhance efficiency and accessibility."
  },
  {
    question: "How does Genix AI improve healthcare delivery?",
    answer: "Genix AI improves healthcare delivery through automated documentation, real-time language translation, and predictive analytics. It reduces administrative burden, improves patient communication, and helps healthcare providers make data-driven decisions."
  },
  {
    question: "What are the main services Genix AI offers?",
    answer: "Genix AI offers real-time transcription, multilingual support, predictive analytics, patient record management, and seamless integration with existing healthcare systems. Our services are designed to enhance both provider efficiency and patient care."
  },
  {
    question: "What are core features of Genix AI?",
    answer: "Core features include ambient voice recognition, automated medical documentation, multilingual support, predictive analytics, secure data encryption, and integration with existing healthcare systems. All features are designed with healthcare professionals in mind."
  },
  {
    question: "Is Genix AI secure?",
    answer: "Yes, Genix AI implements enterprise-grade security measures including end-to-end encryption, HIPAA compliance, secure data storage, and regular security audits to protect sensitive healthcare information."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-container">
        <h2>What's often asked about us?</h2>
        <div className="faq-list">
          {faqData.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => toggleQuestion(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <button className="toggle-btn">
                  {openIndex === index ? (
                    <svg viewBox="0 0 24 24">
                      <path d="M19 13H5v-2h14v2z" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24">
                      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                    </svg>
                  )}
                </button>
              </div>
              <div className="faq-answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ; 